export const requestURL =
  "https://api.hsforms.com/submissions/v3/integration/submit/6959181/5a65e7b1-a51a-49b7-9424-37cece7bf986/";

export const requestOptions = {
  method: "POST",
  redirect: "follow",
};
